import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.itineraries')
  .service('ItinerariesPageableAPI', ItinerariesPageableAPI);

function ItinerariesPageableAPI(): BringozApi {
  return {
    base: `/itineraries/pageable`,
    actions: {
      getItineraries: {
        address: '',
        cmd: 'GET',
        updateable: true
      }
    }
  }
}
